"use client";
import {
  useHovercardStoreProps
} from "./FTXTWCCT.js";
import {
  useStore,
  useStoreProps
} from "./YV4JVR4I.js";

// src/tooltip/tooltip-store.ts
import * as Core from "@ariakit/core/tooltip/tooltip-store";
function useTooltipStoreProps(store, update, props) {
  useStoreProps(store, props, "type");
  useStoreProps(store, props, "skipTimeout");
  return useHovercardStoreProps(store, update, props);
}
function useTooltipStore(props = {}) {
  const [store, update] = useStore(Core.createTooltipStore, props);
  return useTooltipStoreProps(store, update, props);
}

export {
  useTooltipStoreProps,
  useTooltipStore
};
